import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import pb from '../../services/pocketbase';
import OrderSummaryModal from '../OrderSummaryModal/OrderSummaryModal';
import './CartSidebar.css'; // On importe uniquement le CSS du panier

function CartSidebar() {
  const navigate = useNavigate();
  const { cartItems, isCartOpen, toggleCart, updateQuantity, removeFromCart, cartTotal } = useCart();
  const [showOrderModal, setShowOrderModal] = useState(false);

  const getImageUrl = (item) => {
    const imageName = Array.isArray(item.image) ? item.image[0] : item.image;
    if (item && imageName && item.collectionId && item.id) {
      return pb.files.getURL({
        collectionId: item.collectionId,
        id: item.id
      }, imageName, {'thumb': '100x100'});
    }
    return 'https://via.placeholder.com/100'; // Placeholder image
  };

  return (
    <>
      <div 
        className={`sidebar-overlay ${isCartOpen ? 'show' : ''}`}
        onClick={toggleCart}
      ></div>
      <aside className={`sidebar cart-sidebar ${isCartOpen ? 'open' : ''}`}>
        <header className="sidebar-header">
          <h3>Votre Panier</h3>
          <button onClick={toggleCart} className="close-btn">&times;</button>
        </header>
        <div className="sidebar-content">
          {cartItems.length === 0 ? (
            <p className="empty-message">Votre panier est vide.</p>
          ) : (
            <ul className="sidebar-list">
              {cartItems.map(item => {
                // Sécurité : ne rien afficher si l'item est invalide
                if (!item || typeof item.name === 'undefined' || typeof item.price === 'undefined') {
                  return null;
                }

                return (
                <li key={item.id} className="sidebar-item">
                  <img 
                    src={getImageUrl(item)} 
                    alt={item.name}
                    onClick={() => navigate(`/catalogue/produit/${item.slug}`)}
                    style={{ cursor: 'pointer' }}
                  />
                  <div className="item-details">
                    <span 
                      className="item-name"
                      onClick={() => navigate(`/catalogue/produit/${item.slug}`)}
                      style={{ cursor: 'pointer' }}
                    >
                      {item.name}
                    </span>
                    <span className="item-price">{(item.price || 0).toFixed(2).replace('.', ',')} €</span>
                    <div className="quantity-selector">
                      <button onClick={() => updateQuantity(item.id, -1)} aria-label="Réduire la quantité">-</button>
                      <span>{item.quantity}</span>
                      <button onClick={() => updateQuantity(item.id, 1)} aria-label="Augmenter la quantité">+</button>
                    </div>
                  </div>
                  <div className="item-actions">
                    <span className="item-total-price">
                      {((item.price || 0) * item.quantity).toFixed(2).replace('.', ',')} €
                    </span>
                    <button onClick={() => removeFromCart(item.id)} className="remove-btn" aria-label="Supprimer l'article">&times;</button>
                  </div>
                </li>
              );})}
            </ul>
          )}
        </div>
        <footer className="sidebar-footer">
          <div className="total-price">
            <span>Total</span>
            <span>{cartTotal.toFixed(2).replace('.', ',')} €</span>
          </div>
          <div className="shipping-notice">
            *Frais de livraison non inclus
          </div>
          <button 
            className="checkout-btn" 
            disabled={cartItems.length === 0}
            onClick={() => setShowOrderModal(true)}
          >
            Contacter pour commander
          </button>
        </footer>
      </aside>
      
      <OrderSummaryModal
        isOpen={showOrderModal}
        onClose={() => setShowOrderModal(false)}
        items={cartItems}
        total={cartTotal}
        type="cart"
      />
    </>
  );
}
export default CartSidebar;